import React, { type ReactNode } from 'react';
import styled from 'styled-components/native';
import { H2, H4, P } from '../Typography';
import { SafeAreaView } from 'react-native';
import Spacer from '../Spacer';
import Button from '../Button';
import api from '../../api/api';
import ChloeLogo from '../ChloeLogo';

const StyledScrollView = styled.ScrollView`
  flex: 1 1 auto;
  height: 100%;
`;

const StyledView = styled.View`
  padding: 24px;
  align-items: center;
`;

const StyledImageView = styled.Image`
  width: 228px;
  height: 148px;
`;

export type ErrorBoundaryProps = {
  children: Exclude<NonNullable<ReactNode>, string | number | boolean>;
};

type State = { error: Error | null };

class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error('ErrorBoundary componentDidCatch', error, info);
    api
      .post('error', {
        error: error.toString(),
        componentStack: `${info.componentStack}\n\n${error.stack}`
      })
      .response.catch(error => console.log(error));
  }

  resetError: () => void = () => {
    this.setState({ error: null });
  };

  render() {
    return this.state.error ? (
      <SafeAreaView>
        <StyledScrollView contentContainerStyle={{}}>
          <StyledView>
            <Spacer size={3} />
            <ChloeLogo />
            <Spacer size={3} />
            <StyledImageView
              resizeMode='contain'
              source={require('../../assets/error.png')}
            />
            <Spacer size={3} />
            <H2>Oops!</H2>
            <Spacer size={1} />
            <H4>There&apos;s an error</H4>
            <Spacer size={2} />
            <Button size='medium' onPress={this.resetError}>
              Retry
            </Button>
            <Spacer size={3} />
            <P>{this.state?.error?.toString()}</P>
          </StyledView>
        </StyledScrollView>
      </SafeAreaView>
    ) : (
      this.props.children
    );
  }
}

export default ErrorBoundary;
